import { ReactComponent as AccountStore } from './account-store.svg'
export default AccountStore